import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_insert-after",
  "use": "lc_insert-after-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_insert-after\"><path d=\"M726.09 141.15v71.95H142.85v-71.95h583.24m43-43H99.85v158h669.24v-158zM99.85 320.7h669.24v157.95H99.85zM726.09 810.8v72H142.85v-72h583.24m43-43H99.85v158h669.24v-158zM700.86 639.09l223.4 128.44V511.11l-223.4 127.98z\" p-id=\"2657\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol